import { React, useEffect} from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import dayjs from "dayjs";

import { useDispatch, useSelector } from "react-redux";
import {
  updateRequest,
  fetchDeviceMapRequest
} from "../../../../store/actions/deviceMap";
import usDateFormatLast7Days from "../../../../global/utility/usDateFormatLast7Days";

function ViewDeviceMapFilter(props) {
  const { id, mapRef, intervalRef, popupRef } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateRequest(usDateFormatLast7Days(new Date())));
  }, [])

  const {startDateTime, endDateTime, mapData} = useSelector(
    (state) => ({
      startDateTime: state.deviceMap.startDateTime,
      endDateTime: state.deviceMap.endDateTime,
      mapData: state.deviceMap.data
    })
  );
  
  const handleStartDateChange = (val) => {
    const startDate = new Date(val);
    dispatch(
      updateRequest({
        startDateTime: `${startDate.getFullYear()}-${
          (startDate.getMonth() + 1).toString()
          .padStart(2, "0")
        }-${startDate
          .getDate()
          .toString()
          .padStart(2, "0")}T${startDate.toLocaleTimeString("en-US", {
          hour12: false,
        })}`,
      })
    );
  };

  const handleEndDateChange = (val) => {
    const endDate = new Date(val);
    dispatch(
      updateRequest({
        endDateTime: `${endDate.getFullYear()}-${
          (endDate.getMonth() + 1).toString()
          .padStart(2, "0")
        }-${endDate
          .getDate()
          .toString()
          .padStart(2, "0")}T${endDate.toLocaleTimeString("en-US", {
          hour12: false,
        })}`,
      })
    );
  };

  const clearMap = (mapRef) => {
    const map = mapRef.current;

    if (!map.isStyleLoaded()) {
      return;
    }

    const layers = map.getStyle().layers;
    if (layers) {
      
      layers.forEach((layer) => {
        if (layer.id.startsWith("line-") || layer.id.startsWith("marker-")) {
          map.removeLayer(layer.id);
        }
      });
    }

    const sources = map.getStyle().sources;
    if (sources) {
      
      Object.keys(sources).forEach((sourceId) => {
        if (sourceId.startsWith("line-") || sourceId.startsWith("marker-")) {
          map.removeSource(sourceId);
        }
      });
    }

    const customMarkers = document.querySelectorAll(".marker");
    customMarkers.forEach((marker) => marker.remove());
    mapData.forEach((_feature, i) => {
      const heatmapSourceId = `heatmap-source-${i}`;
      const heatmapLayerId = `heatmap-layer-${i}`;

      if (map.getLayer(heatmapLayerId)) {
        map.removeLayer(heatmapLayerId);
      }
      if (map.getSource(heatmapSourceId)) {
        map.removeSource(heatmapSourceId);
      }
    });
  }
  
  const handleFilterApply = () => {
    clearMap(mapRef);
    clearInterval(intervalRef.current);
    popupRef.current = null;
    dispatch(
      fetchDeviceMapRequest({
        id: id
      })
    );
  };

  return (
    <div className="d-flex flex-sm-column flex-md-row justify-content-start align-items-center pt-3 pb-2">
      <div className="d-flex flex-column align-items-start justify-content-start me-2 ">
        <div className="pb-1">Start date and time</div>
        <DatePicker
          className="device-date-picker"
          format="MM-DD-YYYY HH:mm:ss"
          allowClear={false}
          showTime
          onChange={handleStartDateChange}
          value={dayjs(startDateTime)}
        />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start me-2">
        <div className="pb-1">End date and time</div>
        <DatePicker
          className="device-date-picker"
          format="MM-DD-YYYY HH:mm:ss"
          allowClear={false}
          showTime
          value={dayjs(endDateTime)}
          onChange={handleEndDateChange}
        />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start pt-3">
        <button
          className="font-face-vzw device-filter-apply-btn"
          type="button"
          onClick={handleFilterApply}
        >
          Apply
        </button>
      </div>
    </div>
  );
}

ViewDeviceMapFilter.propTypes = {
  id: PropTypes.string.isRequired,
  mapRef: PropTypes.any.isRequired,
  intervalRef: PropTypes.any.isRequired,
  popupRef: PropTypes.any.isRequired
};

export default ViewDeviceMapFilter;
